<template>
  <div class="signup-form" layout layout-align="center-center">
    <form @submit.prevent="submit($v)">
      <el-card>
        <div class="el-card-header">
          <div class="logo"><img src="@/client/assets/images/atelu_logo.svg" /></div>
        </div>
        <div>
          <div class="invite-title" v-if="invitation && invitation.code">
            {{ invitation.group.name }}に参加するために、ユーザー登録してください。
          </div>
          <div class="input-container">
            <el-input :maxlength="100" type="text" v-model="invitation.email" :disabled="true">
              <template slot="prepend"><i class="mdi mdi-email"></i></template>
            </el-input>
          </div>
          <div class="input-container">
            <el-input
              :class="{ error: $v.name.required && $v.name.$error, success: $v.name.required && !$v.name.$invalid }"
              placeholder="お名前"
              :maxlength="60"
              type="text"
              v-model="name"
              @blur="$v.name.$touch"
              tabindex="1"
            >
              <template slot="prepend"><i class="mdi mdi-account"></i></template>
            </el-input>
            <div class="invalid" v-if="!$v.name.required && $v.name.$error">お名前を入力してください。</div>
          </div>
          <div class="input-container">
            <el-input
              :class="{ success: $v.password.required && !$v.password.$invalid }"
              placeholder="パスワード"
              :maxlength="100"
              type="password"
              v-model="password"
              @blur="$v.password.$touch"
              tabindex="2"
            >
              <template slot="prepend"><i class="mdi mdi-key-variant"></i></template>
            </el-input>
            <div class="invalid" v-if="!$v.password.required && $v.password.$error">パスワードを入力してください。</div>
            <div class="input-invalid-text" v-if="!$v.password.minLength && $v.password.$error">
              パスワードは8文字以上にしてください。
            </div>
          </div>
        </div>
        <div class="el-card-confirm mt-x3">
          <el-checkbox class="mr-x1" :class="['confirm-checkbox']" v-model="isCheckPolicy"></el-checkbox
          ><a class="small link" href="https://www.comnico.jp/products/atelu/jp/tos" target="_blank">利用規約</a
          ><span class="small text"> と </span
          ><a class="small link" href="https://www.comnico.jp/privacypolicy" target="_blank">個人情報保護方針</a
          ><span class="small text"> に同意 </span>
        </div>
        <div class="el-card-action mt-x4">
          <el-button type="primary" native-type="submit" :disabled="$v.$invalid === true || isCheckPolicy === false"
            >登録</el-button
          >
        </div>
      </el-card>
    </form>
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.signup-form {
  height: 100%;
}

form {
  width: 100%;
  max-width: $spacing-unit * 62;
}

.el-card {
  width: 100%;
  padding: $spacing-unit * 2;
}

.el-card-header {
  padding: $spacing-unit * 3;

  .logo {
    text-align: center;
  }
}

.invite-title {
  text-align: center;
}

.el-card-action {
  display: block;
  margin: $spacing-unit * 2 0;

  button {
    width: 100%;
  }
}

.input-container {
  width: 100%;
  margin: $spacing-unit * 3 0 0;

  .invalid {
    display: block;
    margin-top: $spacing-unit;
    font-size: $font-small-size;
    color: $danger-color;
  }
}

.small {
  margin-top: $spacing-unit;
}

.el-card-confirm {
  text-align: center;
}

.confirm-checkbox {
  box-shadow: unset;
}
</style>
<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { defineComponent } from 'vue'
import { minLength, required } from 'vuelidate/lib/validators'

import api from '@/client/core/api'

const NEW_USER = 'new_user'

export default defineComponent({
  props: {
    invitation: Object
  },
  data() {
    return {
      name: '',
      password: '',
      isCheckPolicy: false
    }
  },
  methods: {
    /**
     * ログインサブミット
     * @return {void}
     */
    submit: async function ($v: any) {
      // validations
      $v.$touch()
      if ($v.$invalid === true) {
        return
      }

      const params = {
        code: this.invitation.code,
        password: this.password,
        name: this.name,
        type: NEW_USER,
        isGuest: this.invitation.isGuest
      }

      const result = await api.post('/invitations/accept', params)
      if (result.error && result.error.type === 'GROUP_MAX_USER_COUNT_OVER') {
        this.$notify({
          title: 'これ以上ユーザーを追加できません。',
          message: 'グループの登録可能ユーザー数を超えています。',
          customClass: 'danger',
          duration: 10000
        })
        return
      }

      if (result.error) {
        this.$notify({
          title: 'グループ参加処理に失敗しました。',
          customClass: 'danger',
          duration: 10000
        })
        return
      }

      // 登録が成功した場合は、キャンペーン画面に移動する
      if (result.data) {
        this.$notify({
          title: `グループ ${this.invitation.group.name} に参加しました。`,
          customClass: 'success',
          duration: 5000
        })
        // 契約情報入力画面に移動する
        this.$router.push('/settings/group_billing')
        return
      }

      // エラーを表示する
      this.$notify({
        title: 'グループ参加処理に失敗しました。',
        customClass: 'danger',
        duration: 10000
      })
    }
  },
  validations: {
    name: {
      required
    },
    password: {
      required,
      // パスワードは8文字以上が必要
      minLength: minLength(8)
    }
  }
})
</script>
